import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './HeaderBar.module.css'
import { Button, Image, Input, message, Popconfirm, Tooltip } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
export default function HeaderBar(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  return (
    <div
      className={styles.background}
      //  onKeyDown={keyPress}
    >
      {contextHolder}
      <div className={styles.searchContainer}>
        <Input.Search
          enterButton
          onSearch={props.confirmSearch}
          size="large"
          placeholder="查你想知道的..."
          className={styles.searchInput}
        />
        {/* <Tooltip placement="top" title={'点我看视频，快速了解所有功能！'}>
          <div
            className={styles.introduce}
            onClick={(e) => {
              props.playVideo('f0e881c98ebe71f0bf8d1777b3df0102')
              e.stopPropagation()
              e.preventDefault()
            }}
          >
            功能介绍
          </div>
        </Tooltip> */}
      </div>
      <div className={styles.rightContainer}>
        {props.type == '1' ? (
          <Button
            icon={<PlusOutlined />}
            style={{
              borderRadius: '16px',
              height: '56px',
              width: '162px',
              backgroundColor: 'white',
            }}
            // type='primary'
            htmlType="submit"
            color="primary"
            variant="outlined"
            block
            onClick={props.createBot}
          >
            基础智能体
          </Button>
        ) : (
          <Button
            icon={<PlusOutlined />}
            style={{
              borderRadius: '16px',
              height: '56px',
              width: '162px',
              backgroundColor: 'white',
            }}
            // type='primary'
            htmlType="submit"
            color="primary"
            variant="outlined"
            block
            onClick={props.createDataset}
          >
          知识库
          </Button>
        )}
      </div>
    </div>
  )
}
